import ModuleCampaign from 'mfCampaign/Campaign';

/**
 * simple re-export of the campaign module, allowing for mocks
 * (the promise based alias 'mfCampaign/*' cant be mocked directly) to be used in tests
 */
export { ModuleCampaign };
